import React from "react";
import './AddServiceMaster.css';
import { useNavigate } from "react-router-dom";
const AddServiceMaster = () => {
    const navigate =useNavigate();
  const handleCancleButtonClick=()=>{
    navigate ('/serviceMaster');
  };
  const handleAddButtonClick=()=>{
    navigate ('/serviceMaster');
  };
    return (
        <div className="ADD-Service-Master">
            <div className="add-service">
                {/* <h3>Service Master</h3> */}
            </div>
            <div className="add-container">
                <div className="add-Header">
                    <h3>Add Service Master</h3>
                </div>
                <div className="add-container-body">
                    <div className="add-form">
                        <label className="addService-label">Service Name</label>
                        <input className="addService-input" type="text" placeholder=" " />
                    </div>

                    <div className="add-form">
                        <label className="addService-label">Parent Id</label>
                        <select className="addService-select">
                            <option value="" disabled selected>Select</option>
                            <option value="1">Parent 1</option>
                            <option value="2">Parent 2</option>
                            <option value="3">Parent 3</option>
                            <option value="4">Parent 4</option>
                        </select>
                    </div>

                    <div className="add-form">
                        <label className="addService-label">Display Order</label>
                        <input className="addService-input" type="text" placeholder=" " />
                    </div>

                    <div className="addServiceButtons">
                        <button className="addService-btn" onClick={handleAddButtonClick}>ADD</button>
                        <button className="btn-addService" onClick={handleCancleButtonClick}>CANCEL</button>
                    </div>

                </div>
            </div>
        </div>
    );
}
export default AddServiceMaster;